export const LAST_GEO_COOKIE = 'last_stored_geolocation';
export const IS_FIRST_PLAYER_LAUNCH = 'is_first_foodriver_launch';
export const CHALLENGE_EXPIRATION_SECONDS: number = 60;
export const PRE_CHALLENGE_SCREEN_DURATION: number = 3;
export const COUNT_INVITED_FRIENDS_FOR_REWARD: number = 10;
export const CAMPGAIN_ID_QUERY_PARAM = 'campaign_id';
export const START_APP_QUERY_PARAM = 'startapp';
